<template >
  <a-modal title="Review" :visible="modal.visible" :confirm-loading="modal.confirmLoading" @ok="submit()"  @cancel="hide" >
    <a-row >
      <a-col v-for="item in list" :span="12">
        <a-card hoverable style="width: 240px" :bordered="true">
          <img
            slot="cover"
            alt="example"
            :src="item.imgUrl"
          />
        </a-card>
      </a-col>
      <a-col :span="24" >
        <div style="background:#ECECEC; padding:30px">
          <a-card title="order detail" :bordered="false" style="width: 100%">
            <p>Order No.:{{this.order.orderNo}} | Name:{{this.order.name}}</p>
            <p>Phone:{{this.order.mobileNo}} | Principal:{{this.order.capital}}</p>
            <p>Settled Principal:{{this.order.settledCapital}} | Interest:{{this.order.interest}} </p>
            <p>Settled Interest:{{this.order.settledInterest}} | Late Fee:{{this.order.lateFee}}</p>
            <p>Deduction Amount:{{this.order.deductionFee}} | Remaining Amount:{{this.order.repayAmt}}</p>
          </a-card>
        </div>
      </a-col>
      <a-col :span="24" >
        <div style="display: flex;align-items:center;justify-content:center;margin-top: 12px;">
          <a-input v-model="model.settleDate"  style="width: 100%; margin-right: 15px;" placeholder="SettledDate"/>
        </div>
        <div style="display: flex;align-items:center;justify-content:center;margin-top: 12px;">
          <a-input v-model="model.amount" style="width: 100%; margin-right: 15px;" placeholder="ReviewAmount"/>
        </div>
      </a-col>
    </a-row>
    <template slot="footer">
      <a-button type="primary" @click="submitAll()">Offline Full Repayment</a-button>
      <a-button type="primary" @click="submit()">Offline Partial Repayment</a-button>
      <a-button type="primary" @click="hide">Cancel</a-button>
    </template>
  </a-modal>
</template>
<script>
  import {getOrderImageInfoList,reviewImage} from '@/webpublicapi/orderImageInfo'
  import { repayOffline,  repayOfflineAll} from '@/webpublicapi/order'
  export default {
    name: 'CreateGroupModalOrderList',
    data() {
      return {
        modal: {
          visible: false,
          confirmLoading: false,
        },
        form: this.$form.createForm(this),
        model: {
          orderInfoId: 0,
          amount: 0,
          settleDate: ''
        },
        list:[],
        order:{
          capital: 0,
          settledCapital: 0,
          interest: 0,
          settledInterest: 0,
          lateFee: 0,
          deductionFee: 0,
          repayAmt: 0,
          name : '',
          mobileNo : '',
          orderNo : ''
        }
      }
    },
    methods: {
      show(orderInfoId) {
        this.order.capital = orderInfoId.capital;
        this.order.settledCapital = orderInfoId.settledCapital;
        this.order.interest = orderInfoId.interest;
        this.order.settledInterest = orderInfoId.settledInterest;
        this.order.lateFee = orderInfoId.lateFee;
        this.order.deductionFee = orderInfoId.deductionFee;
        this.order.repayAmt = orderInfoId.repayAmt;
        this.order.name = orderInfoId.firstName + ' ' + orderInfoId.secondName + ' ' + orderInfoId.lastName;
        this.order.orderNo = orderInfoId.orderNo;
        this.order.mobileNo = orderInfoId.mobileNo;

        this.list = []
        this.modal.visible = true
        this.model.orderInfoId = orderInfoId.id
        getOrderImageInfoList(this.model).then(res => {
          this.loading = false;
          this.list = res && res.data && res.data.rows;
          this.total = res && res.data && res.data.total;
        }).catch(e => {
          this.loading = false;
          this.$message.error(e.message);
        });
      },
      hide() {
        // this.$message.info("1212121212");
        this.modal.visible = false
        this.model = {
          orderInfoId: 0,
          amount: 0,
          settleDate: ''
        }
      },
      submitAll() {

        var repayAmt = this.model.amount;
        if("0" == repayAmt){
          this.$message.error("AmountcannotIs0");
          return;
        }

        repayOfflineAll({ orderId: this.model.orderInfoId
          , repayAmt: Number(repayAmt), settleDate: this.model.settleDate }).then(res => {

          this.$message.info("Online full repayment success");
          this.hide()
          this.$emit("refresh")
        }).catch(e => {
          this.$message.error(e.message);
        })
      },
      submit() {
        var repayAmt = this.model.amount;
        if("0" == repayAmt){
          this.$message.error("AmountcannotIs0");
          return;
        }

        repayOffline({ orderId: this.model.orderInfoId
          , repayAmt: Number(repayAmt), settleDate: this.model.settleDate }).then(res => {
          this.$message.info("Online partial repayment success");
          this.hide()
          this.$emit("refresh")
        }).catch(e => {
          this.$message.error(e.message);
        })

      }
    }
  }
</script>